import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  List,
  Divider,
  Grid2,
  TextField,
  Alert,
  Popover,
  IconButton,
} from "@mui/material";

import useAsyncEffect from "use-async-effect";
import { useDispatch, useSelector } from "react-redux";
import { setPreferences } from "../redux/userSlice";

import JobListItem from "./JobListItem";
import { setJobs } from "../redux/jobSlice";
import { JobsAPI } from "../apis/jobsApi";
import { PreferencesAPI } from "../apis/preferencesAPI";
import JobDetailsDialog from "./JobDetailsDialog";
import { Tune, Warning } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

const WorkerView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const jobs = useSelector((state: any) => state.jobs.list || []);
  const requests = useSelector((state: any) => state.requests.list || []);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  const [selectedJob, setSelectedJob] = useState({} as any);

  const [currentZipCode, setCurrentZipCode] = useState("");
  const [currentRadius, setCurrentRadius] = useState(0);

  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(new Date()).startOf('day'))
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(new Date()).add(1, 'month'))
  const wildcard = useParams()["*"];

  useEffect(() => {
    setCorrectJobsToShow();
    console.log("it tiggered");
  }, [jobs, requests]); // eslint-disable-line

  useEffect(() => {
    setCurrentZipCode(user.preferences.zip);
    setCurrentRadius(user.preferences.radius);
  }, [user]);

  useEffect(() => {
    if (wildcard && wildcard !== "") {
      const j = jobs.find((j: any) => j.id === wildcard);
      if (j) {
        setSelectedJob(j);
      }
    } else {
      setSelectedJob({});
    }
  }, [wildcard, jobs]);

  const updatePreferences = async () => {
    const body = {} as any;
    if (
      currentZipCode !== user.preferences.zip ||
      currentRadius !== user.preferences.radius
    ) {
      body.zip = currentZipCode;
      body.radius = currentRadius;
    } else {
      return;
    }

    try {
      const newps = await PreferencesAPI.updatePreferences(body);
      dispatch(setPreferences(newps));
      await getJobs();
    } catch (e: any) {
      setCurrentZipCode(user.preferences.zip);
      setCurrentRadius(user.preferences.radius);
      console.log(e.response.data.message);
      alert(e.response.data.message);
    }
  };

  const setCorrectJobsToShow = () => {
    const unassignedJobs = jobs.filter((j: any) => j.assigneeId === null);
    setFilteredJobs(unassignedJobs);
  };

  const getJobs = async () => {
    console.log('HERE HERE ')
    try {

      const queryParams = {
        startDate: startDate?.toISOString().substring(0,10),
        endDate: endDate?.toISOString().substring(0,10),
      }
      console.log('getting and ', queryParams);
      const ts = await JobsAPI.listJobs(queryParams);
      dispatch(setJobs(ts) || []);
    } catch (e) {
      // TODO here we could direct them to sign in page
      console.log("error getting jobs,", e);
    }
  };

  useAsyncEffect(async () => {
      await getJobs()
    }, []);

    useAsyncEffect(async () => {
      await getJobs()
    }, [startDate, endDate]);

  
  const jobsContent = (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        border: "1px none red",
      }}
    >
      {filteredJobs.map((j: any, i: number) => (
        <div key={i}>
          <JobListItem
            requested={requests.some((r: any) => r.jobId === j.id)}
            job={j}
            onSelect={() => {
              navigate(`/jobs/${j.id}`);
              // setSelectedJob(j);
            }}
            onCancel={() => {}}
            onComplete={() => {}}
            onDelete={() => {}}
          />
          {i !== jobs.length - 1 ? (
            <Divider variant="inset" component="li" />
          ) : null}
        </div>
      ))}
    </List>
  );

  const noJobsContent = (
    <Alert
      icon={<Warning fontSize="inherit" />}
      severity="warning"
      style={{ textAlign: "center", justifyContent: "center" }}
    >
      There are no available job posts in your area
    </Alert>
  );

  const handleFiltersClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setFiltersAnchorEl(event.currentTarget);
  };

  const handleFiltersClose = () => {
    setFiltersAnchorEl(null);
  };
  const filtersOpen = Boolean(filtersAnchorEl);
  const filtersId = filtersOpen ? 'filters-popover' : undefined;

  return (
    <>
      <JobDetailsDialog
        job={selectedJob}
        open={!!selectedJob.id}
        handleClose={() => {
          setSelectedJob({});
          window.history.back();
        }}
      />
      <Grid2 container sx={{ margin: "1rem" }}>
        <Grid2 size={12} sx={{ style: "1px none red" }}>
          <Box
            sx={{
              flexGrow: 1,
              border: "1px none green",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>Hi, {user.firstName}!</Typography>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <TextField
                label="Zip"
                value={currentZipCode}
                onChange={(e) => setCurrentZipCode(e.target.value)}
                onBlur={(e) => updatePreferences()}
              />
              <TextField
                label="Radius"
                type="number"
                style={{ marginLeft: "0.5rem" }}
                value={currentRadius}
                onChange={(e) => setCurrentRadius(parseInt(e.target.value))}
                onBlur={(e) => updatePreferences()}
              />
            </Box>
          </Box>
        </Grid2>
        <Grid2
          size={12}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "3rem",
          }}
        >
          <Box>
            <Typography>Find jobs near you</Typography>
          </Box>
          <Box>
            
            <IconButton aria-describedby={filtersId} onClick={handleFiltersClick}>
              <Tune />
            </IconButton>
            <Popover
              id={filtersId}
              open={filtersOpen}
              anchorEl={filtersAnchorEl}
              onClose={handleFiltersClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Grid2 container spacing={2} sx={{display: 'flex', alignItems: 'center', margin: '1rem'}}>
              <Grid2 size={3}>

                    Start Date
                </Grid2>

                <Grid2 size={9}>
                    <DatePicker value={startDate} onChange={(v) => {setStartDate(v)}}/>
                </Grid2>
                <Grid2 size={3}>

                    End Date
                </Grid2>

                <Grid2 size={9}>
                <DatePicker value={endDate} onChange={(v) => {setEndDate(v)}}/>
                </Grid2>

              </Grid2>
              <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
            </Popover>
          </Box>
        </Grid2>

        <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
          {filteredJobs.length > 0 ? jobsContent : noJobsContent}
        </Grid2>
      </Grid2>
    </>
  );
};

export default WorkerView;
